module.exports = __webpack_public_path__ + "static/media/ohio_state.3c76051b.png";